import { Fade } from '@material-ui/core';
import { ReactElement } from 'react';
import Lazy from '@tock/shared/components/Lazy';

interface Props {
  alt?: string;
  backgroundImage?: boolean;
  className: string;
  backgroundColor?: string;
  preload?: boolean;
  src?: string;
  fade?: {
    enterTimeout?: number;
    exitTimeout?: number;
  };
  children?: React.ReactNode;
}

const LazyImage = ({
  alt = 'image',
  backgroundColor,
  backgroundImage,
  children,
  className,
  preload = false,
  src = '',
  fade,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
Props): ReactElement<any, any> | null => {
  const defaultImageStyle = {
    backgroundColor,
  };
  if (backgroundImage) {
    const imageStyle = {
      backgroundColor,
      backgroundImage: `url(${src})`,
    };

    const imgElement = children ? (
      <div className={className} style={imageStyle} title={alt}>
        {children}
      </div>
    ) : (
      <div className={className} style={imageStyle} title={alt} />
    );

    return (
      <Lazy
        preload={preload}
        orElse={<div className={className} style={defaultImageStyle} title={alt} />}
      >
        {fade ? (
          <Fade timeout={{ enter: fade.enterTimeout, exit: fade.exitTimeout }} in={true}>
            {imgElement}
          </Fade>
        ) : (
          imgElement
        )}
      </Lazy>
    );
  }

  const imgElement = <img className={className} style={defaultImageStyle} src={src} alt={alt} />;

  return (
    <Lazy
      preload={preload}
      orElse={<div title={alt} className={className} style={defaultImageStyle} />}
    >
      {fade ? (
        <Fade timeout={{ enter: fade.enterTimeout, exit: fade.exitTimeout }} in={true}>
          {imgElement}
        </Fade>
      ) : (
        imgElement
      )}
    </Lazy>
  );
};

export default LazyImage;
